export default {
  zh_cn: {
    bannerImg: 'zh.png',
    umText: '即将上线',
    requiredLogin: '此游戏须登入',
    jackpotId_1: {
      name: '金龙聚宝奖池',
      level1Jackpot: '至尊奖',
      level2Jackpot: '巨奖',
      level3Jackpot: '大奖',
    },
    jackpotId_2: {
      name: '绒毛派对超级彩池',
      level1Jackpot: '巨奖',
      level2Jackpot: '大奖',
      level3Jackpot: '小奖'
    },
    jackpotId_3: {
      name: '天降金喜奖池',
      level1Jackpot: '首奖',
      level2Jackpot: '大奖',
      level3Jackpot: '小奖',
      level4Jackpot: '迷你奖',
    }
  },
};
